import Paragraph from '@components/UI/Typography/Paragraph';
import pieChart from '@images/pie-chart.png';
import kaggleLogo from '@images/kaggle-logo.png';
import hfLogo from '@images/hf-logo.png';
import React, { Fragment } from 'react';


export default {
    features: [
        {
            alt: 'Employee time tracking - Traqq',
            id: 1,
            icon: {
                name: 'timer',
            },
            title: 'Time tracking'
        },
        {
            alt: 'Employee activity tracking - Traqq',
            id: 2,
            icon: {
                name: 'monitoring',
            },
            title: 'Activity tracking'
        },
        {
            alt: 'Websites usage monitoring - Traqq',
            id: 3,
            icon: {
                name: 'globe',
            },
            title: 'Websites usage monitoring'
        },
        {
            alt: 'Computer programs usage monitoring - Traqq',
            id: 4,
            icon: {
                name: 'app',
            },
            title: 'Computer programs usage monitoring'
        },
        {
            alt: 'Billable hours calculation - Traqq',
            id: 5,
            icon: {
                name: 'check',
            },
            title: 'Billable hours calculation'
        },
        {
            alt: 'Attendance tracking - Traqq',
            id: 6,
            icon: {
                name: 'attendance',
            },
            title: 'Attendance tracking'
        },
        {
            alt: 'Dashboard and data visualization - Traqq',
            id: 7,
            icon: {
                name: 'chart',
            },
            title: 'Dashboard and data visualization'
        },
        {
            alt: 'Easily exportable tabular data - Traqq',
            id: 8,
            icon: {
                name: 'export-1',
            },
            title: 'Easily exportable tabular data'
        }
    ],
    cards: [
        {
            alt: 'Kaggle community',
            desc: 'Kaggle community',
            id: 1,
            image: kaggleLogo,
            title: 'Kaggle community',
            url: 'https://www.kaggle.com/traqqteam/datasets'
        },
        {
            alt: 'Hugging Face community',
            desc: 'Hugging Face community',
            id: 2,
            image: hfLogo,
            title: 'Hugging Face community',
            url: 'https://huggingface.co/traqq'
        },
        {
            alt: 'Time management statistics - Traqq',
            desc: 'Time management statistics',
            id: 3,
            image: pieChart,
            title: 'Time management statistics',
            url: 'https://traqq.com/blog/category/time-management-statistics/'
        }
    ],
    faq: [
        {
            desc:'Traqq offers academic and research institutions all premium features on a free basis for the period of six months to conduct their research.',
            id: 1,
            title: 'Which resources does Traqq provide to educational and research institutions during scientific collaboration?'
        },
        {
            desc:'Universities can collect and utilize various types of data, including:',
            list: [
                'Time tracking insights',
                'Application usage',
                'Website visits',
                'Activity data',
                'Clock-in and clock-out times',
                'Time spent on tasks',
                'Activity Breakdown',
                'Work pattern',
                'Project timeline',
                'Collaboration data',
                'Resource allocation',
                'Engagement levels',
                'Trends over time',
                'Time utilization',
                'Absenteeism and punctuality',
                'Break and downtime analysis',
                'Impact of interventions',
                'Individual and group performance metrics'
            ],
            id: 2,
            title: 'What kind of valuable scientific data can these institutions obtain through scientific collaboration?'
        },
        {
            desc: 'The Traqq team is willing to discuss the possibility of providing an API for educational and research teams on an individual basis.',
            id: 3,
            title: 'Does Traqq offer an API for scientific collaboration?'
        }
    ],
};
